<template>
  <AuthFormWrapper>
    <template v-if="passwordSet">
      <p class="text-center">
        Your password has been set.
      </p>

      <RouterLink :to="{ name: 'app_auth_login' }">
        <i class="fa-regular fa-chevron-left fa-fw" /> Back to login
      </RouterLink>
    </template>

    <template v-else>
      <p>Set your password below</p>

      <SetPasswordForm @password-set="passwordSet = true" />
    </template>
  </AuthFormWrapper>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';

import { SetPasswordForm } from '@/components/forms/index.js';
import { AuthFormWrapper } from '@/components/wrappers/index.js';

const token = useRoute().query.token;
const error = ref(null);
const passwordSet = ref(false);

if (!token) {
  error.value = 'The link to set your password is either invalid or has expired.';
}
</script>
